import React, { useEffect, useState } from "react";
import { datetimeFormatter } from "./utils";

export type DateLabelProps = {
  date: Date;
  format?: string;
};

const SuppressHydrationWarning = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (isClient) {
    return children;
  }

  return <span suppressHydrationWarning>{children}</span>;
};

function DateTime({
  date,
  format = "dd mname yyyy",
}: DateLabelProps): React.ReactElement {
  const formattedDate = datetimeFormatter(date, format || "dd mname yyyy");

  return (
    <time dateTime={date.toISOString()} suppressHydrationWarning>
      <SuppressHydrationWarning>{formattedDate}</SuppressHydrationWarning>
    </time>
  );
}

export default DateTime;
